import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { ICommentsDatasource } from '../../../../../comments/datasources/comments_datasource';
import { INotificationDelegate } from '../../../../../global/helpers/notification_delegate';

class StudentFeedbackCommentsController {
  private comment: any;
  private displayComment: any;
  private showToggle: boolean = false;
  private suggestedPlanStatus: any;
  private openRevokeErrorPopup: boolean = false;
  private truncate: boolean;

  constructor(
    private ngCommentsDatasource: ICommentsDatasource,
    private changeSuggestedPlanStatusCommand: ICommand,
    private $timeout: any,
    private $state: ng.ui.IStateService,
    private ngAPNotificationDelegate: INotificationDelegate
  ) {}

  $onInit() {
    this.truncate = _4.isBoolean(this.truncate) ? this.truncate : this.truncate === 'true';
    this.getLatestComment();
  }

  getLatestComment() {
    // TODO: Complex code can be simplified.
    // TODO: create query and move all this outside
    const allComments = _4.filter(
      this.ngCommentsDatasource.read(),
      (courseFlag) => _4.isEmpty(courseFlag.content_type) && !_4.isEmpty(courseFlag.message)
    );

    this.comment = _4
      .sortBy(
        _4.map(_4.toArray(allComments), (item: any) => {
          item.unixTimestamp = moment(item.updated_ts).unix();
          return item;
        }),
        'unixTimestamp'
      )
      .reverse();
    this.displayComment = this.comment[0];
  }

  acceptAndGotoPlan() {
    this.changeSuggestedPlanStatusCommand('RESOLVED')
      .then(() => {
        this.ngAPNotificationDelegate.success('Successfully read comments.');
        this.$state.go('my.planner.plan.default');
      })
      .catch((error) => {
        if (error.status === 403) {
          this.openRevokeErrorPopup = true;
        } else {
          this.ngAPNotificationDelegate.error('Unable to accept comments.');
        }
      });
  }
}

angular.module('capability-ng-academic-planner').component('studentFeedbackComments', {
  controller: StudentFeedbackCommentsController,
  templateUrl:
    'capability-ng-academic-planner/src/suggestions/components/plan_feedback/components/plan_feedback_comments/plan_feedback_comments.html',
  bindings: {
    truncate: '<',
    title: '@',
    termsAndSuggestions: '<',
    showAccept: '<'
  }
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/suggestions/components/plan_feedback/components/plan_feedback_comments/plan_feedback_comments.ts